module.exports = __webpack_public_path__ + "static/media/logo-2x.fa7e7849.png";